

import { component } from 'picoapp';
import { AccordionItem } from './AccordionItem';

export default component((node, ctx) => {
  class Accordion extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // this.classList.add(styles.accordion);
    }
  }
  if (!customElements.get('accordion-component')) {
    customElements.define('accordion-component', Accordion);
  }
  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', AccordionItem);
  }
});
